import { cn } from '@workspace/lib';
import { ContentCarouselMediaRenderer } from './ContentCarouselMedia';
import { VIDEO_DIMENSIONS, IMAGE_DIMENSIONS } from '../content-carousel.constant';
import { CarouselSlide } from '../content-carousel.types';

interface ContentCarouselMobileMediaProps {
  slides: CarouselSlide[];
  currentIndex: number;
  isImageRight: boolean;
  slideWrapperClass: string;
}

export function ContentCarouselMobileMedia({
  slides,
  currentIndex,
  isImageRight,
  slideWrapperClass,
}: ContentCarouselMobileMediaProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center mt-sm md:hidden w-full',
        'aspect-video rounded-md overflow-hidden',
        slideWrapperClass,
        isImageRight ? 'md:order-3' : 'order-1',
      )}
    >
      <div className="relative w-full h-full">
        {slides?.map((slide) => (
          <ContentCarouselMediaRenderer
            key={slide._key}
            slide={slide}
            isActive={slide._key === slides[currentIndex]?._key}
            imageDimensions={IMAGE_DIMENSIONS}
            videoDimensions={VIDEO_DIMENSIONS}
          />
        ))}
      </div>
    </div>
  );
}
